<template>
  <Search />
</template>

<script>
import Search from './components/search-block/Search-Block.vue'

export default {
  name: 'App',
  components: {
    Search,

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@import'~bootstrap/dist/css/bootstrap.css'
</style>
